var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgAvatarUpload(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_801_17398)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M6.43707 22.6126C2.5849 20.6153 -0.046875 16.5919 -0.046875 11.9531C-0.046875 5.32581 5.32581 -0.046875 11.9531 -0.046875C18.5804 -0.046875 23.9531 5.32581 23.9531 11.9531C23.9531 16.5919 21.3214 20.6153 17.4692 22.6126H6.43707Z",
    fill: "#FDA2C7"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.9531 2.90625C7.01825 2.90625 3.00348 6.6828 3.00348 11.3247V14.4921C3.00348 17.1949 5.03009 19.472 7.7157 19.775C8.84674 19.9028 10.24 19.9847 11.9531 19.9847C13.6663 19.9847 15.0595 19.9028 16.1906 19.775C18.8762 19.472 20.9028 17.1949 20.9028 14.4921V11.3249C20.9028 6.6828 16.888 2.90625 11.9531 2.90625Z",
    fill: "#494A59"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17.4692 22.6125C15.8177 23.4691 13.9417 23.953 11.9531 23.953C9.9646 23.953 8.0885 23.4691 6.43707 22.6125C6.43707 19.7029 9.34058 18.1152 9.34058 18.1152H14.5657C14.5657 18.1152 17.4692 19.7029 17.4692 22.6125Z",
    fill: "#FEDD60"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17.9169 10.7429C17.9169 9.96356 17.3335 9.31134 16.5602 9.21521C13.1944 8.79681 11.9531 6.90625 11.9531 6.90625C11.9531 6.90625 10.7119 8.79681 7.34601 9.21521C6.57275 9.31134 5.98938 9.96356 5.98938 10.7429V15.9235C7.40955 17.5194 9.55371 18.536 11.9531 18.536C14.3525 18.536 16.4967 17.5194 17.9169 15.9235V10.7429Z",
    fill: "#FFD9CC"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_801_17398"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAvatarUpload);
export default __webpack_public_path__ + "static/media/avatar_upload.6726e12d9a5cb5fa33b4ec6173d70e25.svg";
export { ForwardRef as ReactComponent };